/* eslint-disable @typescript-eslint/explicit-function-return-type */
/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import type { ErrorType } from '../../modules/Network/orvalHTTPInterface';
import { HTTP } from '../../modules/Network/orvalHTTPInterface';

import type { BaseUrlsIndex } from './model/baseUrlsIndex';

export const apiBaseUrlsIndexRetrieve = (signal?: AbortSignal) => {
  return HTTP<BaseUrlsIndex>({ url: `/api/v7/`, method: 'GET', signal });
};

export const getApiBaseUrlsIndexRetrieveQueryKey = () => {
  return [`/api/v7/`] as const;
};

export const getApiBaseUrlsIndexRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiBaseUrlsIndexRetrieve>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof apiBaseUrlsIndexRetrieve>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiBaseUrlsIndexRetrieveQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiBaseUrlsIndexRetrieve>>> = ({
    signal,
  }) => apiBaseUrlsIndexRetrieve(signal);

  return {
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof apiBaseUrlsIndexRetrieve>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type ApiBaseUrlsIndexRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiBaseUrlsIndexRetrieve>>
>;
export type ApiBaseUrlsIndexRetrieveQueryError = ErrorType<unknown>;

export function useApiBaseUrlsIndexRetrieve<
  TData = Awaited<ReturnType<typeof apiBaseUrlsIndexRetrieve>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof apiBaseUrlsIndexRetrieve>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getApiBaseUrlsIndexRetrieveQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}
